var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notice" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _c("div", { staticClass: "center" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "center" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.logo },
              on: { error: _vm.handleImageError },
            }),
            _vm.theme == "yellow"
              ? _c(
                  "div",
                  { staticClass: "button", on: { click: _vm.toOpen } },
                  [
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "text" }, [
                          _c("img", {
                            attrs: {
                              src: require("../assets/image/yellow/eye.png"),
                            },
                          }),
                          _vm._v("查看公告原文"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "text" }, [
                          _c("img", {
                            attrs: {
                              src: require("../assets/image/yellow/eye.png"),
                            },
                          }),
                          _vm._v("OPEN"),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "button", on: { click: _vm.toOpen } },
                  [
                    _vm.language === "zh"
                      ? _c("div", { staticClass: "text" }, [
                          _c("img", {
                            attrs: {
                              src: require("../assets/image/red/eye.png"),
                            },
                          }),
                          _vm._v("查看公告原文"),
                        ])
                      : _vm.language === "en"
                      ? _c("div", { staticClass: "text" }, [
                          _c("img", {
                            attrs: {
                              src: require("../assets/image/red/eye.png"),
                            },
                          }),
                          _vm._v("OPEN"),
                        ])
                      : _vm._e(),
                  ]
                ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }